import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { BeautyInfo } from 'shared/src/api/getMemberInfo/types';

type LogParams = {
  height: number | null;
  weight: number | null;
  topLabel: string | null;
  bottom: number | null;
  shoes: number | null;
  skinTone: BeautyInfo | null;
  skinType: BeautyInfo | null;
  skinProblems: BeautyInfo[];
  from: string | undefined;
};

export const useLogCompleteEditMyPersonalization = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (params: LogParams) => {
      logAnalyticsEvent({
        name: 'COMPLETE_EDIT_MY_PERSONALIZATION',
        channel: ['firebase', 'facebook', 'amplitude', 'braze', 'ablylog'],
        analytics: {
          HEIGHT: params.height,
          WEIGHT: params.weight,
          TOP: params.topLabel,
          PANTS: params.bottom,
          SHOES: params.shoes,
          SKIN_TONE: params.skinTone?.name ?? null,
          SKIN_TYPE: params.skinType?.name ?? null,
          SKIN_PROBLEMS: `[${params.skinProblems.map(p => p.name).join(', ')}]`,
          FROM: params.from ?? null,
        },
      });
    },
    [logAnalyticsEvent],
  );
};
